// TODO: refactor jQuery --> ES
export default class Covid {
	constructor(app) {
		this.app = app;

		$(".js-covid-popup-toggle").click(function (e) {
			$(".js-covid-popup").addClass("is-active");
			$(".js-popup-overlay").addClass("is-active");

			let $covidForm = $(".js-covid-send").closest("form");
			let $skeyInput = $covidForm.find("input[name=skey]");
			$.ajax({
				type: "POST",
				url: "/json/skey", // getSkey
				dataType: "json",
				success: function (skey) {
					$skeyInput.val(skey) // update Skey
				}
			})
		});

		$(".js-covid-popup-close").click(function (e) {
			$(".js-covid-popup").removeClass("is-active");
			$(".js-popup-overlay").removeClass("is-active");
		});

		$(".js-popup-overlay").click(function (e) {
			$(".js-covid-popup").removeClass("is-active");
			$(".js-popup-overlay").removeClass("is-active");
		});
	}
}



